var _title, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMist = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-cloud-wind-3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.809,13.5A.248.248,0,0,0,2,13.412a.245.245,0,0,0,.057-.2A4.5,4.5,0,0,1,6.581,8h0a1,1,0,0,0,.986-.834,5,5,0,0,1,9.647-.831,1,1,0,0,0,.9.667,2.5,2.5,0,0,1,2.232,3.365,1,1,0,0,0,.366,1.169,3,3,0,0,1,.816,4.077.253.253,0,0,0-.039.158c.007.075.011.151.011.228s0,.153-.01.227a.249.249,0,0,0,.249.273H23c.054,0,.108,0,.162,0a.248.248,0,0,0,.236-.13,4.993,4.993,0,0,0-.885-5.932.252.252,0,0,1-.071-.218A4.6,4.6,0,0,0,22.5,9.5a4.491,4.491,0,0,0-3.517-4.393.248.248,0,0,1-.171-.136,7,7,0,0,0-12.988.916.251.251,0,0,1-.205.173A6.509,6.509,0,0,0,0,12.5a6.594,6.594,0,0,0,.058.872.253.253,0,0,0,.109.174.249.249,0,0,0,.2.035A2.481,2.481,0,0,1,1,13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,17a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,18H4a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H1a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMist, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mist.3cd4d0a7.svg";
export { ForwardRef as ReactComponent };